import React from 'react';
import { Modal, CloseIcon } from '../../../../components';
import classes from './threeSixthModal.module.css';

var ThreeSixtyModal = function ThreeSixtyModal(_ref) {
  var link = _ref.link,
      isOpen = _ref.isOpen,
      closeModal = _ref.closeModal,
      productName = _ref.productName;
  return React.createElement(Modal, {
    isOpen: isOpen,
    size: "full",
    toggleModal: closeModal
  }, React.createElement("div", {
    className: classes.wrapper
  }, React.createElement("iframe", {
    className: "h-full w-full",
    src: link,
    title: productName
  })), React.createElement("div", {
    className: classes.closeButton,
    onClick: closeModal
  }, React.createElement(CloseIcon, null)));
};

export default ThreeSixtyModal;